const { getElements } = window.BAO.Utils

class SectionStockist extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this._country = ''
    this._query = ''
    this._type = ''

    this.type = this.els.view.elements[0].dataset.type
    this.viewEl = this.els.view.elements[0]
  }

  setupListeners () {
    super.setupListeners()

    this.handleButtonClick = this.handleButtonClick.bind(this)

    this.listeners.add(this, 'click', this.handleButtonClick)

    if (this.els.countries?.exists) {
      this.handleCountryUpdate = this.handleCountryUpdate.bind(this)

      this.listeners.add(
        this.els.countries?.element,
        'change',
        this.handleCountryUpdate,
      )
    }

    if (this.els.input?.exists) {
      this.handleInput = this.handleInput.bind(this)
      this.debouncedOnInput = window.BAO.Utils.debounce(this.handleInput, 500)
      this.handleSubmit = this.handleSubmit.bind(this)

      this.listeners.add(
        this.els.input?.element,
        'input',
        this.debouncedOnInput,
      )
      this.listeners.add(this.els.form?.element, 'submit', this.handleSubmit)
    }
  }

  handleButtonClick (event) {
    const clickedButtonEl = event.target.closest(this.els.button?.selector)
    if (!clickedButtonEl) return

    this.type = clickedButtonEl.dataset.type
  }

  handleCountryUpdate () {
    this.country = this.els.countries.element.value || ''
  }

  handleInput () {
    this.query = this.els.input.element.value || ''
  }

  handleSubmit (event) {
    event.preventDefault()
    this.handleInput()
  }

  setupDropdown () {
    if (!this.els.countries?.exists) return

    const options = { context: this.viewEl }
    const titleEls = getElements(this.els.title.selector, options)
    const countries = titleEls.map((titleEl) => titleEl.dataset.country)

    this.els.countries.element.innerHTML = ''

    this.createOption('', this.dataset.string)
    countries.forEach((country) => this.createOption(country, country))

    this.updateDropdownWidth()
  }

  createOption (value, text) {
    const optionEl = document.createElement('option')
    optionEl.value = value
    optionEl.innerText = text

    this.els.countries.element.insertAdjacentElement('beforeend', optionEl)
  }

  updateDropdownWidth (country) {
    if (!this.els.countries?.exists) return

    const text = country || this.els.countries.element.options[0].innerText

    const spacer = document.createElement('span')
    spacer.classList.add('fz-13_100')
    spacer.innerText = text

    this.insertAdjacentElement('beforeend', spacer)
    const width = spacer.offsetWidth
    spacer.remove()

    this.els.countries.element.style.width = `${width}px`
  }

  updateView () {
    // Update button
    this.els.button?.elements.forEach((buttonEl) => {
      if (buttonEl.dataset.type === this.type) {
        buttonEl.classList.replace('btn-Button-light', 'btn-Button-dark')
        return
      }

      buttonEl.classList.replace('btn-Button-dark', 'btn-Button-light')
    })

    // Update view
    this.els.view?.elements.forEach((viewEl) => {
      if (viewEl.dataset.type === this.type) {
        viewEl.removeAttribute('hidden')
        return
      }

      viewEl.setAttribute('hidden', '')
    })
  }

  handleAttributeUpdate () {
    const options = { context: this.viewEl }
    const titleEls = getElements(this.els.title.selector, options)
    const stockistEls = getElements(this.els.stockist.selector, options)

    this.updateElements(stockistEls, titleEls)

    window.scrollTo(0, 0)
  }

  updateElements (stockistEls, titleEls) {
    const visibleStockistCountries = []

    // Show stockists based on country and query
    stockistEls.forEach((stockistEl) => {
      const stockistCountry = stockistEl.dataset.country

      let hasCountryMatch = true
      let hasQueryMatch = true

      if (this.country) {
        hasCountryMatch = stockistCountry === this.country
      }

      if (this.query) {
        const hasAddressMatch = stockistEl.dataset.address.includes(this.query)
        const hasNameMatch = stockistEl.dataset.name.includes(this.query)
        const hasRegionMatch = stockistEl.dataset.region.includes(this.query)

        hasQueryMatch = hasAddressMatch || hasNameMatch || hasRegionMatch
      }

      if (hasCountryMatch && hasQueryMatch) {
        stockistEl.removeAttribute('hidden')

        if (!visibleStockistCountries.includes(stockistCountry)) {
          visibleStockistCountries.push(stockistCountry)
        }

        return
      }

      stockistEl.setAttribute('hidden', '')
    })

    // Show titles if respective stockist is visible
    titleEls.forEach((titleEl) => {
      const titleCountry = titleEl.dataset.country

      let hasCountryMatch = true
      let hasStockistsVisible = true

      if (this.country) {
        hasCountryMatch = titleCountry === this.country
      }

      if (this.query) {
        hasStockistsVisible = visibleStockistCountries.includes(titleCountry)
      }

      if (hasCountryMatch && hasStockistsVisible) {
        titleEl.removeAttribute('hidden')
        return
      }

      titleEl.setAttribute('hidden', '')
    })

    // Empty state
    if (visibleStockistCountries.length) {
      this.els.empty.element.setAttribute('hidden', '')
      return
    }

    this.els.empty.element.removeAttribute('hidden')
  }

  get country () {
    return this._country
  }

  set country (value) {
    this._country = value

    this.updateDropdownWidth(value)
    this.handleAttributeUpdate()
  }

  get query () {
    return this._query
  }

  set query (value) {
    this._query = value.toLowerCase()
    this.handleAttributeUpdate()
  }

  get type () {
    return this._type
  }

  set type (value) {
    this._type = value

    this.viewEl = this.els.view.elements.find((element) => {
      return element.dataset.type === value
    })

    this.setupDropdown()
    this.updateView()

    if (this.els.countries?.exists) {
      this.els.countries.element.value =
        this.els.countries.element.options[0].value
    }

    if (this.els.input?.exists) {
      this.els.input.element.value = ''
    }

    this.country = ''
    this.query = ''
  }
}

if (!customElements.get('section-stockist')) {
  customElements.define('section-stockist', SectionStockist)
}
